export interface Lookup {
  ID: number
  Title: string
  text?: string
}

export enum LookupsServiceErrorCode {
  GENERAL,
}

export type Lookups = Lookup[]

export interface LookupsServerData {
  [key: string]: Lookups
}

export enum LookupType {
  System = 'sys',
  City = 'LOC_City',
  ProductsFull = 'products_full',
  ProductsLimited = 'products_limited',
  ProductsLimited2 = 'products_limited2',
  Vehicles = 'vehicles',
  Rates = 'rates',
  Search = 'search',
  LoanView = 'loanview',
  Users = 'users',
  Account = 'acc',
  AccountBalanceCodes = 'accbalcodes',
  EntryDeleteReason = 'entry_del_reason',
  Collateral = 'collateral',
  Templates = 'templates',
}
